export default __webpack_public_path__ + "static/media/sounds/maze_model_correct_answer_selected.mp3";